// @flow
export const state: Object = {
  items: []
};

export const getters = {
  items: (state: Object) => state.items
};

export const mutations = {
  SET_ITEMS(state: Object, items: Array<Object>) {
    state.items = items;
  }
};

export const actions = {
  setItems({ commit }: Action, items: Array<Object>) {
    commit('SET_ITEMS', items);
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
